import {ConfigConstant} from '../constants/config';
import NavigationListConstant from '../constants/navigationLists';
import PageLayoutEnum from '../enum/pageLayout';
const createNavWithPermissions = (routeList, userType) => {
  const currentAccessObj = {};

  const pageAccessList = routeList.filter(
    (item) =>
      item?.showRoute &&
      (item?.componentProps?.layout === PageLayoutEnum.LISTING ||
        item?.componentProps?.layout === PageLayoutEnum.FULL_WIDTH)
  );
  pageAccessList.forEach((item) => {
    currentAccessObj[item.path] = item.showRoute;
  });

  const finalNavBarList = NavigationListConstant.filter((item) => {
    let check = false;
    if (currentAccessObj[item?.link] === true) {
      check = true;
    }

    const finalSubArray = item?.subArray?.filter((list) => {
      if (currentAccessObj[list.link] === true) {
        check = true;
        return list;
      }
      return [];
    });
    if (finalSubArray) {
      item.subArray = finalSubArray;
    }
    if (check) {
      return item;
    }
    return [];
  });

  return finalNavBarList;
};

const createPermissions = (permissionList) => {
  const config = ConfigConstant.PERMISSIONS;
  const permissionMap = createPermissionMap(permissionList);
  const result = assignKeysToPermissionObject(config, permissionMap);
  return {
    read: result?.admin?.isAdminWrite || result?.admin?.isAdminRead || result?.phoenix?.phoenixRead,
    admin: result?.admin?.isAdminWrite,
    editOutlet: result?.admin?.isAdminWrite || result?.outlet?.editWrite,
    createOutlet: result?.admin?.isAdminWrite || result?.outlet?.createWrite,
    bulkOutletSync: result?.outlet?.bulkOperationsWrite,
  };
};
const assignKeysToPermissionObject = (data, permissionMap) =>
  Object.fromEntries(
    Object.entries(data).map(([category, {keys, values}]) => {
      const categoryResult = keys.reduce((result, key, index) => {
        const value = values[index];
        if (permissionMap.has(value)) {
          const permissionType = permissionMap.get(value);
          result[key] = permissionType === 'read' || permissionType === 'write';
        }
        return result;
      }, {});
      return [category, categoryResult];
    })
  );

const createPermissionMap = (permissions) => {
  const permissionMap = new Map();
  for (const permission of permissions) {
    permissionMap.set(permission.permissionName, permission.permissionType);
  }
  return permissionMap;
};

export {createPermissions, createNavWithPermissions};
